export default {
    PENDING: 0,
    ANSWERD: 1,
    CLOSED: 2,
    UNDER_INVESTIGATION: 3,
    CREATED_BY_ADMIN: 4,
}